import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { pluck, map } from 'rxjs/operators';
import { EquipmentOverviewService } from '../../services/equipment-overview.service';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { CompletedOverviewService } from '../../services/completed-overview.service';
import { Observable, Subscription } from 'rxjs';
import { ObjectDescriptionService } from 'src/app/services/object-description.service';
import { SectionOverviewData } from './section-overview-data-model';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { environment } from 'src/environments/environment';
import dayjs from 'dayjs';
import { GeaMesDatepickerModule } from '@gea-mes/datepicker';
import { MatTooltip } from '@angular/material/tooltip';
import { NgIf, NgFor, NgStyle, PercentPipe } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { MatCard, MatCardHeader, MatCardTitle, MatCardSubtitle, MatCardContent } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatDivider } from '@angular/material/list';

@Component({
    selector: 'app-section-overview',
    templateUrl: './section-overview.component.html',
    styleUrls: ['./section-overview.component.scss'],
    imports: [GeaMesDatepickerModule, MatTooltip, NgIf, MatButton, MatCard, MatCardHeader, MatCardTitle, MatCardSubtitle, MatIcon, MatMenuTrigger, MatMenu, NgFor, MatMenuItem, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, NgStyle, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatCardContent, MatDivider, PercentPipe]
})
export class SectionOverviewComponent implements OnInit {

  currentSite: string;
  siteSubSections: any[];
  subSectionsExist: boolean;
  subMenuDataExists: boolean;
  dateRangeStart: string;
  dateRangeEnd: string;
  displayedColumns: string[];
  dataSource: MatTableDataSource<any>;
  displayName: string;
  sectionOverviewData: SectionOverviewData[];
  siteMenuData: any;
  sectionMenuData: any;
  subSectionMenuData: any;
  currentSection: string;
  currentSubSection: string;
  currentEnvironment: string;
  getSectionDataObservable: Observable<any>;
  sectionOverviewObservable: Observable<any>; 
  sectionOverviewSubscription: Subscription;
  completeOverviewObservable: Observable<any>; 
  completeOverviewSubscription: Subscription;
  menuDataObservable: Observable<any>;
  menuDataSubscription: Subscription;
  mobile: boolean;
  currentDate: string;
  currentDateObj: Date;
  colorChangeThreshold: number;  
  fromDateString: string;
  toDateString: string;
  
  constructor(private activatedRoute: ActivatedRoute,
    private sectionOverview: EquipmentOverviewService,
    private router: Router,
    private CompletedOverviewService: CompletedOverviewService,
    private objDescriptionService: ObjectDescriptionService,
    private breakpointObserver: BreakpointObserver) { 
      this.displayedColumns = ['Section', 'Daily', 'Weekly', 'Biweekly', 'Monthly']
      this.dataSource = new MatTableDataSource<any>();
      this.currentSite = this.activatedRoute.snapshot.paramMap.get('site')
      this.currentSection = this.activatedRoute.snapshot.paramMap.get('section')
      this.currentSubSection = this.activatedRoute.snapshot.paramMap.get('subSection')
      this.currentDate = dayjs().format('YYYY-MM-DD')

      console.debug('Current Date: ' + this.currentDate);

      this.colorChangeThreshold = .85
    }

  ngOnInit() {

    if (this.currentSection === null){
      this.currentSection = "All"
    }

    this.breakpointObserver
      .observe([Breakpoints.Small, Breakpoints.Handset])
      .subscribe((state: BreakpointState) =>{
        if (state.matches){
          this.mobile = true
        } else {
          this.mobile = false
        }
      })
  }

  ngOnDestroy() {
    if (this.sectionOverviewSubscription) this.sectionOverviewSubscription.unsubscribe();
    if (this.menuDataSubscription) this.menuDataSubscription.unsubscribe();
  }

  fetch(){
    this.getMenuData()
    this.getSectionData()
  }

  getSectionData(){
    if (this.sectionOverviewSubscription) this.sectionOverviewSubscription.unsubscribe();
    this.sectionOverviewObservable = this.sectionOverview.getSectionOverview(this.fromDateString, this.toDateString, this.currentDate, this.currentSite).pipe(
      pluck('Body'),
      map(data => {
        this.displayName = data['DisplayName']
        this.getSectionMenuData(this.displayName);
        for (let i in data["MetricsArray"]) {
          let objName = Object.keys(data["MetricsArray"][i])[0]
          
          if (data["MetricsArray"][i][objName]['Complete']['SHIFT'] === undefined){
            data["MetricsArray"][i][objName]['Complete']['SHIFT'] = -1
          }

          if (data["MetricsArray"][i][objName]['Complete']['WEEK'] === undefined){
            data["MetricsArray"][i][objName]['Complete']['WEEK'] = -1
          }
          
          if (data["MetricsArray"][i][objName]['Complete']['BIWEEKLY'] === undefined){
            data["MetricsArray"][i][objName]['Complete']['BIWEEKLY'] = -1
          }

          if (data["MetricsArray"][i][objName]['Complete']['MONTH'] === undefined){
            data["MetricsArray"][i][objName]['Complete']['MONTH'] = -1
          }

          if (data["MetricsArray"][i][objName]['PercentComplete']['SHIFT'] === undefined){
            data["MetricsArray"][i][objName]['PercentComplete']['SHIFT'] = "NA"
          }

          if (data["MetricsArray"][i][objName]['PercentComplete']['WEEK'] === undefined){
            data["MetricsArray"][i][objName]['PercentComplete']['WEEK'] = "NA"
          }
          
          if (data["MetricsArray"][i][objName]['PercentComplete']['BIWEEKLY'] === undefined){
            data["MetricsArray"][i][objName]['PercentComplete']['BIWEEKLY'] = "NA"
          }

          if (data["MetricsArray"][i][objName]['PercentComplete']['MONTH'] === undefined){
            data["MetricsArray"][i][objName]['PercentComplete']['MONTH'] = "NA"
          }

          
        }
        
        return data
      })
    )
    
    this.sectionOverviewSubscription = this.sectionOverviewObservable.subscribe((data) =>{
      this.sectionOverviewData = this.filterData(data["MetricsArray"])
      this.dataSource.data = this.filterData(data["MetricsArray"])
    })
  }

  filterData(dataSet: any[]): any[] {
    let filterDataSet = []
    if (this.currentSubSection && this.currentSubSection != 'All'){
      let filteredSectionOverviewData = dataSet.filter(obj => obj.Section.SubSection == this.currentSubSection)
      filterDataSet = filteredSectionOverviewData
    }
    else if (this.currentSection == "All"){
      filterDataSet = dataSet
    } 
    else {
      let filteredSectionOverviewData = dataSet.filter(obj => obj.Section.Section == this.currentSection)
      filterDataSet = filteredSectionOverviewData
    }

    return filterDataSet
  }

  getMenuData(){
    if (this.menuDataSubscription) this.menuDataSubscription.unsubscribe();

    this.menuDataObservable = this.CompletedOverviewService.completedDashData().pipe(
      pluck('Body')
    )
    
    this.menuDataSubscription = this.menuDataObservable.subscribe((menuData) =>{
      this.siteMenuData = menuData
    })
  }

  getSectionMenuData(displayName:string){
    this.objDescriptionService.getSiteSectionList().subscribe((siteData:any) =>{
      if (siteData != null){
        let siteDataFiltered = siteData.find( ({site }) => site === displayName) 
        this.sectionMenuData = 'sections' in siteDataFiltered ? siteDataFiltered['sections'] : [];
        this.currentSection === 'All' ? this.subSectionMenuData = [] : this.subSectionMenuData = siteDataFiltered[this.currentSection];
        this.setSubSectionColumn(siteDataFiltered)
      }
    }) 
  }

  setSubSectionColumn(siteDataFiltered: any[]): void {
    if (this.currentSection != 'All') {
      let siteDataFilteredForSection = siteDataFiltered[this.currentSection]
      let siteDataFilteredForSectionLength = siteDataFilteredForSection.length
      if (siteDataFilteredForSectionLength > 0) {
        this.subSectionsExist = true
        this.subMenuDataExists = true
        this.subSectionMenuData = siteDataFiltered[this.currentSection]
        
        if (this.currentSubSection == null){
          this.currentSubSection = 'All'
        }
        
      } else {
        this.subSectionsExist = false
      }
    
    } else if (this.currentSection === 'All') {
      let subSectionsData = siteDataFiltered['subSections']
      let lenSubSect = subSectionsData.length
      this.subSectionsExist = lenSubSect > 0 ? true : false
    } else {
      this.subSectionsExist = false
    }

    if (this.subSectionsExist) {
      this.displayedColumns = ['Section', 'SubSection', 'Daily', 'Weekly', 'Biweekly', 'Monthly']
    } else {
      this.displayedColumns = ['Section', 'Daily', 'Weekly', 'Biweekly', 'Monthly']
    }
  }

  navToSection(section){
    let buildUrl = "/dashboard/section-overview/" + this.currentSite + '/' + section 
    this.router.navigate([buildUrl])
  } 

  changeSite(site){
    let buildUrl = "/dashboard/section-overview/" + site
    this.router.navigate([buildUrl])
    this.currentSite = site
    this.currentSubSection = null
    this.getSectionData();
    this.getMenuData();
  }

  changeSection(section:string, subSection:string){
    let buildUrl:string = '';
    if (subSection == null){
      buildUrl = "/dashboard/equipment-overview/" + this.currentSite + '/' + section 
    }
    else{
      buildUrl = "/dashboard/equipment-overview/" + this.currentSite + '/' + section + '/' + subSection
    }
    this.router.navigate([buildUrl]);    
  }

  changeSubSection(subSection: string, section: string = this.currentSection) {
    let buildUrl = "/dashboard/equipment-overview/" + this.currentSite + '/' + section + '/' + subSection
    this.router.navigate([buildUrl])
    this.currentSubSection = subSection
    this.getSectionData();
    this.getMenuData();
  }
  
  navToEnterprise(){
    let buildUrl = "/dashboard/overview-metrics/"
    this.router.navigate([buildUrl])
  }  

  navToSSRS(){
    let urlToReport = environment.SSRSreports 
    window.open(urlToReport,'_blank')
  }

  onDateSelection(e) {
    let utcOffset:number = dayjs(e.start).utcOffset() * -1;

    this.fromDateString = dayjs(e.start).add(utcOffset,'minute').format('YYYY-MM-DD');
    this.toDateString = dayjs(e.end).format('YYYY-MM-DD');

    console.debug('Selected Date Range: ' + this.fromDateString + ' - ' + this.toDateString);

    this.fetch();
  }

}